import { useTranslation } from "react-i18next";
import { Spiner } from "../spiner";
import Class from "../../assets/icons/class.svg";
import { MarkDownViwer } from "../markDownViwer";
import comming from "./../../assets/icons/comming-soon-doodle.svg";
import classNames from "classnames";
import { useDate } from "../../hooks/useDate";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Label para mostrar los mensajes de error del formulario
 * @param {*} param0 
 * @returns 
 */
export const LabelError = ({ errors, name }) => {
    let destructors = name.split(".");
    destructors = destructors.reduce((acc, current) => acc?.[current], errors);
    const message = destructors?.message;
    return (
        <span className="input-error p-0">
            {message ||""}&nbsp;
        </span>
    );
}

/**
 * Indicador de cargando
 * @param {*} param0 
 * @returns 
 */
export const LoadIndicator = ({ loading = true, label }) => {
    if (!loading) return null;
    return (
        <div className="flex items-center gap-[8px] ">
            <Spiner />
            <label className='text-white'>{label}...</label>
        </div>
    )
}

/**
 * Cabecera para el campo de Input
 * @param {*} param0 
 * @returns 
 */
export const HeaderInputComponent = ({ viewmode, labelkey, labelInstruction, labelInstructio2, labelInstructio2ex, labelInstructio3 }) => {
    const { t } = useTranslation();
    return (
        <div className={classNames("flex flex-col flex-1 mt-0",{"mb-4 mt-8":!viewmode})}>
            {labelkey && (
                <label className={classNames("input-label mx-0 p-0 ", { "text-3 my-0 py-0 font-bold": viewmode })}>
                    {t(labelkey)}
                </label>
            )}
            {labelInstruction ?
                <>
                    <label className="input-instruction p-0 !min-h-[20px] mt-2">
                        {t(labelInstruction)}
                    </label>
                </>
                : null}
            {labelInstructio2ex ?
                <>
                    <label className="input-instruction p-0 px-[20px] mt-4">
                        "{t(labelInstructio2ex)}"
                    </label>
                </>
                : null}
            {labelInstructio2 ?
                <>
                    <label className="input-instruction p-0 px-[20px] mt-4">
                        <MarkDownViwer markdown={labelInstructio2} />
                    </label>
                </>
                : null}
            {labelInstructio3 ?
                <>
                    <label className="input-instruction p-0 mt-4">
                        {t(labelInstructio3)}
                    </label>
                </>
                : null}
        </div>
    );
}

//Mostrar la fecha de creacion
export const DateAddedViwer = ({ date }) => {
    const { t, dateToString } = useDate();
    const dateStr = useMemo(() => date ? dateToString(new Date(date)) : null, [date, dateToString]);
    if (!dateStr) return null;
    return (
        <div className="text-Yellow-500 text-3 mt-0">
            {t("added")}:&nbsp;&nbsp;
            {dateStr}
        </div>
    );
}

/**
 * Pantalla 
 * @param {*} param0 
 * @returns 
 */
export const AvailableSoon = ({ messagekey, message2key }) => {
    const { t } = useTranslation();
    return (
        <div className="w-full h-full flex flex-col justify-center items-center text-white gap-4 text-[16px] my-16">
            <img src={comming} alt="Comming soon" className="w-[176px] h-[315px]" />
            <div className="font-bold text-[23px]">{t("comingSoon")}</div>
            <div className="w-[560px] text-center">
                {t(messagekey)}
            </div>
            <div className=" w-[560px] text-center">
                {t(message2key)}
            </div>
        </div>
    );
}

/**
 * Header de la pagina 
 * @param {*} param0 
 * @returns 
 */
export const HeaderScreenPath = ({ name, labelkey = "my_groups", path }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleBack = () => {
        if (!path) return;
        navigate(path);
    };
    return (
        <div className="flex flex-row gap-1 items-center justify-start h-fit">
            <span className="w-6 h-6">
                <img src={Class} alt="empty" className="max-w-full" />
            </span>
            <h4 className="text-Grey-500 font-semibold flex-1 m-0 uppercase text-lg">
                <span className="cursor-pointer" onClick={() => handleBack()}>
                    {t(labelkey)}
                </span>{" "}
                {name ?
                    <>
                        /
                        <span className="text-shaiaBlue uppercase font-bold ml-1">
                            {name}
                        </span>
                    </> :
                    null}
            </h4>
        </div>
    )
}

